<template lang="pug">
  modal(:closeButton='closeButton' @closeModal='hideElement(askForInformationModal)')
    form.image-container.column.center.middle(@submit.prevent='onSubmit' novalidate)
      h2.text-xbig
        | {{ $t('informationProgram.title') }}
      h3.title-medium.m-bottom-5
        | {{ $t('informationProgram.subtitle') }}
      .row
        .column.center.m-right-4
          button.white.m-bottom-1(type='button' @click='toggleButton("innovation")')
            simple-svg(:filepath='medalIcon' :width='"24px"' :height='"24px"' :class='buttonClass(innovation)')
          p.text-small
            | {{ $t('informationProgram.innovation') }}
        .column.center.m-right-4
          button.white.m-bottom-1(type='button' @click='toggleButton("thematic")')
            simple-svg(:filepath='thematicIcon' :width='"24px"' :height='"24px"' :class='buttonClass(thematic)')
          p.text-small
            | {{ $t('informationProgram.thematic') }}
        .column.center
          button.white.m-bottom-1(type='button' @click='toggleButton("author")')
            simple-svg(:filepath='userOneIcon' :width='"24px"' :height='"24px"' :class='buttonClass(author)')
          p.text-small
            | {{ $t('informationProgram.author') }}
      p.text-normal.m-top-5.self-start.m-bottom-1
        | {{ $t('informationProgram.messageLabel') }}
      textarea.self-start.text-area.text-normal(:placeholder='$t("informationProgram.messagePlaceholder")' v-model='message')
      button.primary-button.m-top-2.self-end(type='submit' :disabled="!innovation && !author && !thematic")
        | {{ $t('informationProgram.send') }}
</template>

<script>
import { mapState, mapActions } from 'vuex'

import Modal from '@/components/Modal'

import medalIcon from '@/assets/ic_medal.svg'
import thematicIcon from '@/assets/ic_tema.svg'
import userOneIcon from '@/assets/ic_user_one.svg'

import { requestEducationalProgramInformation } from '@/services/EducationalProgramService'
import { requestInformationCategories } from '@/utils/constants'
import { routes } from '../../router'
import { languagesCodes } from '../../constants/languages'

export default {
  components: { Modal },
  props: {
    closeButton: { type: Boolean, required: false, default: true }
  },
  data() {
    return {
      askForInformationModal: {
        element: 'askForInformationModal'
      },
      thanksModal: {
        element: 'thanksModal'
      },
      medalIcon,
      thematicIcon,
      userOneIcon,
      message: null,
      innovation: false,
      thematic: false,
      author: false,
      categories: requestInformationCategories
    }
  },
  computed: {
    ...mapState({
      user: state => state.userInfo,
      program: state => state.educationalProgram.educationalProgram,
      resource: state => state.resource.resource,
      locale: state => state.behavior.locale
    })
  },
  methods: {
    ...mapActions([
      'hideElement',
      'showElement',
      'requestResourceInformation'
    ]),
    toggleButton(field) {
      this[field] = !this[field]
    },
    async onSubmit() {
      this.categories[0].active = this.innovation
      this.categories[1].active = this.thematic
      this.categories[2].active = this.author
      const activeIds = this.categories.filter(category => category.active).map(active => active.id)
      if (this.$route.name === routes.educationalProgram) {
        requestEducationalProgramInformation({
          userId: this.user.userInfo.userId,
          educationalProgramId: this.program.id,
          comment: this.message,
          locale: languagesCodes[this.locale],
          categories: activeIds
        })
      } else {
        await this.requestResourceInformation({
          userId: this.user.userInfo.userId,
          educationalProgramId: this.resource.educationalProgram.id,
          resourceId: this.resource.id,
          comment: this.message,
          locale: languagesCodes[this.locale],
          categories: activeIds
        })
      }
      this.hideElement(this.askForInformationModal)
      this.showElement(this.thanksModal)
    },
    buttonClass(condition) {
      return condition ? 'rounded-blue white-icon' : 'rounded-white blue-icon'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/variables/colors';

.image-container {
  height: 100%;
  width: 100%;
}

.rounded-white {
  background-color: $white;
  border: 2px solid $blue;
  border-radius: 50%;
  box-sizing: border-box;
  padding: 14px;
}

.rounded-blue {
  background-color: $blue;
  border: 2px solid $white;
  border-radius: 50%;
  box-sizing: border-box;
  padding: 14px;
}

.text-area {
  background-color: $white;
  border: 1px solid $gray;
  border-radius: 6px;
  box-sizing: border-box;
  height: 100px;
  max-width: 400px;
  padding: 13px;
  position: relative;
  resize: none;
  width: 100%;
}
</style>
